(function () {
  function closest(el, selector) {
    if (!el) return null;
    return el.closest ? el.closest(selector) : null;
  }

  function getVariantIdFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get("variant");
    } catch (e) {
      return null;
    }
  }

  function getCurrentVariantIdFromForm() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value ? input.value : null;
  }

  function parseVariantImageMap(galleryRoot) {
    if (!galleryRoot) return {};

    var wrapper = galleryRoot.parentElement || document;
    var mapEl = wrapper.querySelector("[data-dai-variant-image-map]");

    if (!mapEl) {
      mapEl = document.querySelector("[data-dai-variant-image-map]");
    }

    if (!mapEl) return {};

    try {
      return JSON.parse(mapEl.textContent || "{}");
    } catch (e) {
      return {};
    }
  }

  function setActiveThumb(galleryRoot, url) {
    if (!galleryRoot || !url) return;

    var thumbs = galleryRoot.querySelectorAll("[data-dai-thumb-url]");
    thumbs.forEach(function (thumb) {
      if (thumb.getAttribute("data-dai-thumb-url") === url) {
        thumb.classList.add("is-active");
      } else {
        thumb.classList.remove("is-active");
      }
    });
  }

  function updateMainImage(galleryRoot, url) {
    if (!galleryRoot || !url) return;

    var mainImage = galleryRoot.querySelector("[data-dai-main-image]");
    if (!mainImage) return;

    if (mainImage.getAttribute("src") !== url) {
      mainImage.setAttribute("src", url);
    }

    setActiveThumb(galleryRoot, url);
  }

  function updateImageForVariant(galleryRoot, variantId) {
    if (!galleryRoot || !variantId) return;

    var map = parseVariantImageMap(galleryRoot);
    var rec = map[String(variantId)];
    var url = rec && rec.primary_image_url;

    if (url) {
      updateMainImage(galleryRoot, url);
    }
  }

  function updateAllGalleriesForCurrentVariant() {
    var variantId = getVariantIdFromUrl() || getCurrentVariantIdFromForm();
    if (!variantId) return;

    document.querySelectorAll("[data-dai-product-gallery]").forEach(function (galleryRoot) {
      updateImageForVariant(galleryRoot, variantId);
    });
  }

  document.addEventListener("click", function (event) {
    var thumb = closest(event.target, "[data-dai-thumb-url]");
    
    // Handle arrow clicks
    var prevArrow = closest(event.target, ".dai-gallery-arrow--prev");
    var nextArrow = closest(event.target, ".dai-gallery-arrow--next");
    
    if (prevArrow || nextArrow) {
      event.preventDefault();
      event.stopPropagation();
      var arrow = prevArrow || nextArrow;
      var galleryRoot = closest(arrow, "[data-dai-product-gallery]");
      if (!galleryRoot) return;
      
      var thumbs = Array.from(galleryRoot.querySelectorAll("[data-dai-thumb-url]"));
      if (thumbs.length <= 1) return;
      
      var activeIndex = thumbs.findIndex(t => t.classList.contains("is-active"));
      if (activeIndex === -1) activeIndex = 0;
      
      var nextIndex = activeIndex;
      if (prevArrow) {
        nextIndex = activeIndex > 0 ? activeIndex - 1 : thumbs.length - 1;
      } else if (nextArrow) {
        nextIndex = activeIndex < thumbs.length - 1 ? activeIndex + 1 : 0;
      }
      
      var url = thumbs[nextIndex].getAttribute("data-dai-thumb-url");
      updateMainImage(galleryRoot, url);
      return;
    }

    if (!thumb) return;

    var galleryRoot = closest(thumb, "[data-dai-product-gallery]");
    var url = thumb.getAttribute("data-dai-thumb-url");

    updateMainImage(galleryRoot, url);
  });

  document.addEventListener("change", function () {
    window.setTimeout(updateAllGalleriesForCurrentVariant, 100);
  });

  document.addEventListener("variant:change", function (event) {
    var variant = event.detail && event.detail.variant;

    if (!variant || !variant.id) {
      updateAllGalleriesForCurrentVariant();
      return;
    }

    document.querySelectorAll("[data-dai-product-gallery]").forEach(function (galleryRoot) {
      updateImageForVariant(galleryRoot, variant.id);
    });
  });

  window.addEventListener("popstate", updateAllGalleriesForCurrentVariant);
  document.addEventListener("DOMContentLoaded", updateAllGalleriesForCurrentVariant);
})();
